.comment {

	&[data-view="default"] {

		.comment_form {
			position: relative;
			display: flex;
			align-items: center;

			textarea {
				padding-right: 90px !important;
			}
		}

		.comment_bottom {
			font-size: 10px !important;
		}

		.comment_bottom_btn {
			padding: 0 !important;
			font-size: 10px !important;
		}

		.comment_files__title {
			display: block;
			font-size: 12px;
		}

		.comment_send_btn {
			position: absolute !important;
			right: 45px;
		}

		&[data-files-disabled="true"] {

			.comment_send_btn {
				right: 0;
			}
		}
	}

	&[data-view="buttonsBelow"] {
	}

	.comment_files {
		flex: 1;
		margin-top: 10px;
	}

	.comment_text {
		line-height: 19px;
	}

	.comment_reply_wrapper {
		margin-bottom: 5px;
		padding-left: 13px;
		border-left: 4px solid #68c555;
	}
}
